import React from 'react'

export default function ErrorPage() {
  return (
    <div className="row">
      <div className="col-md-8 offset-md-2">
        <div
          className="card justify-content-center align-items-center shadow"
          style={{ marginTop: '50px' }}
        >
          <div className="card-body text-center">
            <h4 className="card-title">Whoops!</h4>
            <h6 className="card-subtitle">Something's awry. Reload the page to keep learning!</h6>
          </div>
        </div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/ui/errorPage/ErrorPage.js